export default class WWW {
  static async fetchJSON(url) {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status} for URL: ${url}`);
    }
    return await response.json();
  }

  static async fetchTSV(url) {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status} for URL: ${url}`);
    }
    const text = await response.text();

    const lines = text.replaceAll("\r", "").trim().split("\n");

    if (lines.length === 0) {
      return [];
    }
    const headers = lines[0].split("\t");
    return lines.slice(1).map((line) => {
      const values = line.split("\t");
      return headers.reduce((obj, header, index) => {
        obj[header] = values[index];
        return obj;
      }, {});
    });
  }

  static async fetch(url) {
    if (url.endsWith(".json") || url.endsWith(".topojson")) {
      return await this.fetchJSON(url);
    }
    if (url.endsWith(".tsv")) {
      return await this.fetchTSV(url);
    }
    throw new Error(`Unsupported file format for URL: ${url}`);
  }
}
